module.exports = __webpack_public_path__ + "static/purchasing-staticLR-61e0347c0c98ea2b5d63810c8fafcbec.jpg";